export default __webpack_public_path__ + "static/media/inesctec.f84284c0.png";